import React, { useEffect, useState } from "react";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import PartyMailDetail from "./PartyMailModal/PartyMailDetail";
import PartyMailList from "./PartyMailModal/PartyMailList";
import PartyMailInfo from "./PartyMailModal/PartyMailInfo";
import { atom, useSetRecoilState } from "recoil";

interface PartyMailModalProps {
  closeEvent: () => void;
  mailId?: string;
  isInviteMail?: boolean;
  secondaryMailAcc?: string;
  partyData?: {
    member: string;
    memberEmail: string;
    party: string;
    emailRegTime: string;
  };
  subsId?: number;
  type?: string;
}

export interface IMailDetail {
  body: string;
  date: string;
  from: string;
  subject: string;
}

export const mailRefreshState = atom({
  key: "mailRefreshState",
  default: false,
});

export default function PartyMailModal({
  closeEvent,
  mailId,
  partyData,
  secondaryMailAcc,
  subsId,
  type,
}: PartyMailModalProps) {
  console.log(partyData);
  console.log(secondaryMailAcc);

  const [mailIndex, setMailIndex] = useState(0);
  const [step, setStep] = useState(0);
  const [click, setClick] = useState({
    isClick: false,
    url: "",
    data: {
      receiver: "",
      url: "",
      sender: "",
    },
  });
  const [mailData, setMailData] = useState<IMailDetail>({
    body: "",
    date: "",
    from: "",
    subject: "",
  });

  const [mailStatus, setMailStatus] = useState<string | undefined>("");
  const setRefetch = useSetRecoilState(mailRefreshState);
  const [timeStamp, setTimeStamp] = useState("");

  // 메일 상세
  const { response: detailResponse, loading: detailLoading } = useApi({
    method: "post",
    url:
      click?.isClick && type === "mailgun"
        ? `party/mailList/detail`
        : undefined,
    data: {
      url: `${click?.url}`,
    },
  });

  // db 메일 상세
  const { response: newDetailResponse, loading: newDetailLoading } = useApi({
    method: "get",
    url: type === "db" && mailIndex > 0 ? `mail/${mailIndex}` : undefined,
  });

  useEffect(() => {
    if (detailResponse?.data || newDetailResponse?.data) {
      console.log(detailResponse);

      setMailData({
        body: newDetailResponse?.data?.html ?? detailResponse?.data?.body,
        date:
          newDetailResponse?.data?.date ??
          detailResponse?.data?.date ??
          timeStamp,
        from: newDetailResponse?.data?.from ?? detailResponse?.data?.from,
        subject:
          newDetailResponse?.data?.subject ?? detailResponse?.data?.subject,
      });

      setStep(1);

      setClick((prev) => ({
        ...prev,
        isClick: false,
        url: "",
      }));
    }
  }, [detailResponse, newDetailResponse]);

  return (
    <DefaultModalLayout
      modalTitle={
        partyData
          ? step === 0
            ? "파티 초대 메일함"
            : "파티 초대 메일"
          : !subsId
          ? step === 0
            ? "링키드 메일함"
            : "링키드 메일"
          : "파티 메일함"
      }
      backBtn={step === 1 ? true : false}
      closeEvent={() => closeEvent()}
      confirmEvent={() => closeEvent()}
      cancelBtn={<></>}
      confirmBtnText="닫기"
      backBtnEvent={() => setStep(0)}
      contentPadding={step === 1 && partyData ? "10px 32px 0 32px" : undefined}
      refreshBtnShow={step === 0 ? true : false}
      refreshBtnClickEvent={() => {
        setRefetch(true);
      }}
    >
      <>
        {/* step: 0 파티 정보 (인바이트 메일)*/}
        {step === 0 && partyData && (
          <PartyMailInfo
            partyData={partyData}
            secondaryMailAcc={secondaryMailAcc}
          />
        )}

        {/* step: 0 메일 목록 */}
        {step === 0 && (
          <PartyMailList
            setClick={setClick}
            setMailStatus={setMailStatus}
            isInviteMail={secondaryMailAcc ? false : partyData ? true : false}
            partyData={partyData}
            mailId={secondaryMailAcc ?? mailId}
            setTimeStamp={setTimeStamp}
            secondaryMailAcc={secondaryMailAcc}
            subsId={subsId}
            saveMailIndex={(id: number) => setMailIndex(id)}
            type={type}
          />
        )}

        {/* step: 1 메일 상세 보기 */}
        {step === 1 && (
          <PartyMailDetail
            mailData={mailData}
            mailStatus={mailStatus}
            user={partyData?.member}
            party={partyData?.party}
            resendData={
              secondaryMailAcc
                ? click?.data
                : {
                    id: mailIndex,
                    receiver: mailId ?? partyData?.memberEmail ?? "",
                    sender: mailData?.from,
                    url: "",
                  }
            }
            goToList={() => setStep(0)}
            isSecondaryMail={Boolean(secondaryMailAcc)}
          />
        )}

        {(detailLoading || newDetailLoading) && <Loader />}
      </>
    </DefaultModalLayout>
  );
}
